import { useState } from 'react';

export const CertificatesState = () => {
    const [menuAnchor, setMenuAnchor] = useState({current: null, toggled: false})
    const [filter, setFilter] = useState({toggled: false, academy: {active: 0, value: 0}, others: {active: 0, value: 0.0}})
    const [academy, setAcademy] = useState({list: null, counts: 0, view_type: 'card', iscroll: false})
    const [others, setOthers] = useState({list: null, counts: 0, view_type: 'card', iscroll: false, remove: {step: 1}})
    const [removed, setRemoved] = useState({list: null, counts: 0, view_type: 'list', iscroll: false, checked: {from: '', list: []}})
    const [info, setInfo] = useState({detailed: null, preview: null, remove: null, premove: false, restore: false})
    const [form, setForm] = useState({
        toggled: false,
        method: null,
        step: 1,
        inputs: {
            certid: null,
            profession: {value: '', stat: false, msg: ''},
            title: {value: '', stat: false, msg: ''},
            dot: {value: '', stat: false, msg: ''},
            type: {value: '', toggled: false, stat: false, msg: ''},
            cpd: {value: '1.5', stat: false, msg: ''},
            ca: {value: '', stat: false, msg: ''},
            file: {value: null, object: null, name: 'default_avatar', type: 'default', size: 0, updated: false, stat: false, msg: ''}
        }
    })
    return {
        academy: {data: academy, set: setAcademy},
        others: {data: others, set: setOthers},
        removed: {data: removed, set: setRemoved},
        info: {data: info, set: setInfo},
        menuAnchor: {data: menuAnchor, set: setMenuAnchor},
        form: {data: form, set: setForm},
        filter: {data: filter, set: setFilter},
    }
}